import React from "react";
import styled from "styled-components";
import GlobalStyles from "../Styles/Index";
import { PrimaryButton } from "../Button/Index";
import { Colors } from "../../assets/Res/Colors";

import UserIcon from "../../assets/Icons/user.svg";
import LogoIcon from "../../assets/Images/logo.svg";
import { IconIMG } from "../Images/Index";
import { SearchInput } from "../Input/Index";

const HomeNavBarWrapper = styled.div`
  width: 80%;
  margin: 0px 10% 0px 10%;
`;

const ActionMenu = styled.div`
  width: 20%;
`;

export const HomeNavBar = () => {
  return (
    <>
      <HomeNavBarWrapper style={{ ...GlobalStyles.HorizontalFlex }}>
        <IconIMG icon={LogoIcon} width={"180px"} height={"50px"} />
        <ActionMenu style={{ ...GlobalStyles.HorizontalFlex }}>
          <PrimaryButton
            text={"Download App"}
            color={Colors.YELLOW}
            bgColor={Colors.RED}
            width={"70%"}
          />
          <IconIMG icon={UserIcon} width={"50px"} height={"50px"} />
        </ActionMenu>
      </HomeNavBarWrapper>
    </>
  );
};

const TrackNavBarWrapper = styled.div`
  width: 80%;
  margin: 0px 10% 0px 10%;

  @media (max-width: 1400px){
    width: 100%;
    flex-direction: column;
    margin: 0px;
  }
`;

const HeadText = styled.p`
  width: 20%;
  text-align: left;
  font-size: 2rem;
  text-transform: capitalize;
  font-family: Helvetica;

  @media (max-width: 1400px){
    width: 100%;
  }
`;

export const TrackNavBar = ({ trackingID, setTrackingID, handleTrack }) => {

  return (
    <>
      <TrackNavBarWrapper style={{ ...GlobalStyles.HorizontalFlex }}>
        <HeadText>Tracking</HeadText>
        <SearchInput
          placeholder={"Search with Track ID..."}
          width={"60%"} value={trackingID}
          onChange={(e) => setTrackingID(e.target.value)}
          onClick={() => handleTrack()} />
        <PrimaryButton
          text={"Turn on Notification"}
          color={Colors.YELLOW}
          bgColor={Colors.RED}
          padding={'5px'}
          width={'20%'}
          smallWidth={"50%"}

        />
      </TrackNavBarWrapper>
    </>
  );
};
